module.exports = __webpack_public_path__ + "static/media/salsichaemp.1d6b256e.webp";